import * as React from 'react';

import TextWrapper from '../text-wrapper';

import NotificationRowCtrl from '../notification-row';

export interface NotificationTextCtrlProps {
  className?: string;
  isRead: boolean;
  imgSrc: string;
  imgAlt?: string;
  children: React.ReactNode;
  timestamp: string;
  id: string;
  clearNotification: (id) => void;
  notificationClick?: () => void;
}

export const NotificationTextCtrl: React.FC<NotificationTextCtrlProps> = ({
  className,
  isRead,
  imgSrc,
  imgAlt,
  children,
  timestamp,
  id,
  clearNotification,
  notificationClick,
}) => {
  return (
    <NotificationRowCtrl
      isRead={isRead}
      imgSrc={imgSrc}
      imgAlt={imgAlt}
      timestamp={timestamp}
      className={className}
      id={id}
      clearNotification={(id) => clearNotification(id)}
      notificationClick={notificationClick}
    >
      <TextWrapper
        justifyContent="flex-start"
        alignItems="baseline"
        isRead={isRead}
      >
        {children}
      </TextWrapper>
    </NotificationRowCtrl>
  );
};

export default NotificationTextCtrl;
